<template>
  <div class="app-body-container" style="padding-bottom: 30px">
    <div class="report-content">
      <div style="padding: 0 30px">
        <div>
          <p class="subtitle">数据接入平台</p>
          <p>请添加需要对接的第三方系统平台，成功对接后方可使用订单机器人服务</p>
        </div>
        <div>
          <el-button type="primary" @click="addDialogVisible=true">添加平台</el-button>
        </div>
        <div class="platform-list" v-loading="loading">
            <div class="platform"
                 v-for="(item,item_idx) in platformList"
                 :key="item_idx"
                 >
              <el-card class="box-card">
                <div style="text-align: center">
                  <img src="static/img/avatar.png" alt="">
                  <p>{{item.name}}</p>
                </div>
                <div style="text-align: center;padding-top: 20px">
                  <el-button type="info" v-if="item.isBind==1" @click="setBind(item.id,'0')">取消绑定</el-button>
                  <el-button type="primary" v-if="item.isBind==0" @click="setBind(item.id,'1')">绑定</el-button>
                </div>
              </el-card>
            </div>
        </div>
      </div>
    </div>

    <!--dialog 新增-->
    <el-dialog title="添加平台" :visible.sync="addDialogVisible"
               class="mydialog mydialog_add_order_audit_rule" :append-to-body="true">
      <div>
        <span class="subtitle">可接入的第三方平台</span>
        <div>
          <p>ERP</p>
          <el-button v-for="(item,item_idx) in data_platformAll"
                      v-if="item.value2=='erp'"
                      :key="item_idx"
                     :class="selectCode==item.code?'my-sel-button-active':'my-sel-button'"
                     @click="selectCode=item.code"
                     plain>{{item.value}}</el-button>
        </div>
        <div>
          <p>电商平台</p>
          <el-button v-for="(item,item_idx) in data_platformAll"
                      v-if="item.value2=='mall'"
                      :key="item_idx"
                     :class="selectCode==item.code?'my-sel-button-active':'my-sel-button'"
                     @click="selectCode=item.code"
                     plain>{{item.value}}</el-button>
        </div>
        <div>
          <p>商家自建平台</p>
          <el-button v-for="(item,item_idx) in data_platformAll"
                      v-if="item.value2=='self'"
                      :key="item_idx"
                     :class="selectCode==item.code?'my-sel-button-active':'my-sel-button'"
                     @click="selectCode=item.code"
                     plain>{{item.value}}</el-button>
        </div>
      </div>
      <div slot="footer">
        <el-button class="mybtn-blue2" @click="addPlatformOk()">确定</el-button>
        <el-button @click="addDialogVisible=false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data: function () {
        return {
            addDialogVisible:false,
            data_platformAll:[],
            platformList:[],
            selectCode:'',
            loading:false
        }
    },
    methods:{
        getPlatformList: function(){
            let self = this;
            //self.loading = true;
            self.xFetch.post(self.xApi('/robot/platform/getPlatformList'), {}).then(function (res) {
                //self.loading = false;
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                self.platformList = res.data.data;
            });
        },
        addPlatformOk: function(){
            let self = this
            if(!self.selectCode){
                self.xEui.msg_error('请选择要添加的平台');
                return;
            }
            self.xEui.myloading('添加中...')
            self.xFetch.post(self.xApi('/robot/platform/addPlatform'), {
                code: self.selectCode
            },{xPostType:'form'} ).then(function (res) {
                self.xEui.loading_close()
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else{
                    self.xEui.msg_success('添加成功')
                    self.addDialogVisible = false;
                    self.getPlatformList();
                }
            });
        },
        setBind: function(id,val){
            let self = this
            self.xEui.myloading('操作中...')
            self.xFetch.post(self.xApi(val=='1'?'/robot/platform/bind':'/robot/platform/unbind'), {
                id: id
            },{xPostType:'form'} ).then(function (res) {
                self.xEui.loading_close()
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else{
                    self.xEui.msg_success('操作成功')
                    self.getPlatformList();
                }
            });
        }
    },
    created: function(){
        let self = this

        // 获取所有平台列表
        self.xFetch.post(self.xApi('/robot/platform/platformData'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_platformAll = res.data.data;
        });

        // 加载已经添加的平台
        self.getPlatformList();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .subtitle{
        font-size: 16px;
        font-weight: bold;
        margin-right: 20px;
    }
    .box-card {
        width: 265px;
    }
    .platform-list{ padding-top: 20px;min-height: 250px }
    .platform{
        margin: 0px 20px 20px 0;
        display: inline-block;
    }
    .my-sel-button{
        color: #606266 !important;
        border-color: #dcdfe6 !important;
    }
    .my-sel-button-active{
        color: #3a8ee6 !important;
        border-color: #3a8ee6 !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/config/data-in.vue